<template>
	<el-drawer :wrapperClosable="false" :visible.sync="userDetailsVisble" size="900px" :show-close="false">
		<template #title>
			<div style="height: 50px">
				<drawer-header :title="userDetailsTitle" :is-add="false" @close="handleClose" />
			</div>
		</template>
		<div style="padding: 0px 20px;">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<div>
					<h2>{{userRuleInfo.name}}</h2>
				</div>
				<div>
					<el-button type="danger" plain v-show="userRuleInfo?.devices?.length > 0" style="margin-right: 20px"
						size="small" @click="handleDeletePermission(userRuleInfo.id)">清除全部权限</el-button>
				</div>
			</div>
			<div v-if="!userRuleInfo || !userRuleInfo?.devices || userRuleInfo?.devices?.length == 0" style="text-align: center;">
				<img src="@/assets/nexus/permissionAllot/emptyUserRule.png" style="margin-top: 200px;" />
				<div style="color: gray;">暂无设备门禁规则...</div>
			</div>
			<div v-else>
				<el-card shadow="never" class="device-user-rule" style="margin-bottom: 20px;"
					v-for="(deviceRule,index) in userRuleInfo.devices" :key="index">
					<template #header>
						<div style="display: flex;justify-content: space-between;align-items: center;">
							<div :span="10" style="font-weight: 1000;">
								{{deviceRule.name}}({{deviceRule.sn}})
							</div>
							<div :span="10" style="color:#9a9a9a">
								有效期：{{deviceRule.periodStartTime}} ~ {{deviceRule.periodEndTime}}
							</div>
							<div :span="4">
								<el-button type="danger" plain size="mini"
									@click="handleDeletePermission(userRuleInfo.id,deviceRule.id)">删除门禁规则</el-button>
							</div>
						</div>
					</template>
					<el-collapse v-model="activeNames">
						<el-collapse-item :name="index">
							<template #title>
								<div style="font-weight: 800;">
									规则名称：{{deviceRule?.rule?.name}}
								</div>
							</template>
							<el-row :gutter="24">
								<el-col :span="12" v-for=" (rule,ruleIndex) in deviceRule?.rule?.rules" :key="ruleIndex" style="margin-top: 10px;">
									<el-card shadow="never" style="height: 200px; overflow-y: auto;">
										<template #header>
											<div style="font-weight: 600;">
												{{formatterDay(ruleIndex)}}
											</div>
										</template>
										<div>
											<div v-for="(interval, intervalIndex) in rule.intervals" :key="intervalIndex"
												style="margin: 10px;">
												规则时段
												<el-time-picker is-range size="small" style="width: 240px;" disabled
													v-model="rule.intervals[intervalIndex]" range-separator="~"
													format="HH:mm" value-format="HH:mm">
												</el-time-picker>
											</div>
										</div>
									</el-card>
								</el-col>
							</el-row>
						</el-collapse-item>
					</el-collapse>
				</el-card>
			</div>
		</div>
	</el-drawer>
</template>

<script>
	import DrawerHeader from "@/components/drawerHeader.vue"
	import {
		DeviceUserTimeRuleApi
	} from "@/api/nexus/deviceUserRule"
	export default {
		components: {
			DrawerHeader
		},
		data() {
			return {
				userDetailsTitle: '',
				userDetailsVisble: false,
				//用户规则信息
				userRuleInfo: {},
				activeNames: []
			}
		},
		methods: {
			//打开弹窗
			async show(userId) {
				let {
					code,
					data
				} = await DeviceUserTimeRuleApi.queryByUserId(userId);
				if (code == 200) {
					this.userRuleInfo = data || {};
					this.userDetailsTitle = "个人权限"
					this.userDetailsVisble = true;
				}

			},
			//规则显示星期格式化
			formatterDay(index) {
				switch (index) {
					case "mon":
						return "星期一";
					case "tue":
						return "星期二";
					case "wed":
						return "星期三";
					case "thu":
						return "星期四";
					case "fri":
						return "星期五";
					case "sat":
						return "星期六";
					case "sun":
						return "星期天";
				}
			},
			//清除权限
			handleDeletePermission(userId, deviceId) {
				this.$confirm("是否删除该用户权限？", '提示').then(async () => {
					let param = {
						userId: userId,
						deviceId: deviceId
					};
					let {
						code,
						data
					} = await DeviceUserTimeRuleApi.deleteById(param);
					if (code == 200) {
						this.$message.success("删除成功")
						this.userDetailsVisble = false;
					} else {
						this.$message.error("删除失败")
					}
				}).catch(()=>{
					
				})
			},
			handleClose() {
				this.userDetailsVisble = false;
			}
		}
	}
</script>

<style>
	.device-user-rule>.el-card__header {
		background: aliceblue;
	}
</style>